import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectAddAssemblyPage } from '@/areas/assemblies/AssemblyForm/pages/ProjectAddAssemblyPage';
import { assembliesEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/assemblies/$assemblyId/subassemblies/create',
)({
    staticData: {
        access: { permissions: ['create:assembly'], modulePermissions: assembliesEditModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

// `$assemblyId` is the parent: the top-level assembly, whose id is the project's, or a subassembly.
function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectAddAssemblyPage projectId={pathParams.projectId} parentAssemblyId={pathParams.assemblyId} />;
}
